<template>
  <div class="row mt-2">
    <div class="col-md-12">
      <label>
        <input type="checkbox" name="isMultiLine" v-model="control.isMultiLine" @change="editSidebar">
        <span
          v-back-to-default="[
            $parent.inheritedControlInfo,
            control,
            'isMultiLine',
            $parent.backToDefault
          ]"
        />
        <span>Multi-line?</span>
      </label>
    </div>
  </div>
</template>

<script>
  export default {
    name: "TextConfigComponent",
    props: {
      control: {
        type: Object,
      },
      editSidebar: {
        type: Function,
      }
    },
  }
</script>
